"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryAssignedNodes = o;

var _base = require("./base.js");

var _queryAssignedElements = require("./query-assigned-elements.js");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function o(o, n, r) {
  var l,
      s = o;
  return "object" == _typeof(o) ? (s = o.slot, l = o) : l = {
    flatten: n
  }, r ? (0, _queryAssignedElements.queryAssignedElements)({
    slot: s,
    flatten: n,
    selector: r
  }) : (0, _base.decorateProperty)({
    descriptor: function descriptor(e) {
      return {
        get: function get() {
          var e, t;
          var o = "slot" + (s ? "[name=".concat(s, "]") : ":not([name])"),
              n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
          return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
        },
        enumerable: !0,
        configurable: !0
      };
    }
  });
}